import { useContext, useEffect, useMemo, useState } from "react";
import { ToastContext } from "../../../context/ToastContext";
import _ from "underscore";
import { calculateWordsFromString } from "../../../utils/Helper";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { callautopopulate } from "../../../services/callautopop";


export const useProdServerAccess = ({ setShowRequestPopup, editData, setEditData, callApi }) => {

    const { showInfo, showSuccess, showError } = useContext(ToastContext);
    const [popupFilters, setPopupFilters] = useState({ project: {}, server: {}, database: {}, approve_by: 0, reason: "", time: { label: "30 min", value: 30 } });
    const [previousData, setPreviousData] = useState({ project: {}, server: {}, database: [], approve_by: 0, reason: "", time: { label: "30 min", value: 30 } });
    const [loader, setLoader] = useState(false);
    const [options, setOptions] = useState({
        projects: [], server: [], database: [], approveBy: [],
        time: [{ label: "30 min", value: 30 }, { label: "1 hr", value: 60 }, { label: "2 hr", value: 120 }, { label: "3 hr", value: 180 }, { label: "4 hr", value: 240 },]
    });

    useEffect(() => {
        sessionStorage.removeItem("server_access_projects");
        callautopopulate("server_access_projects").then(res => {
            setOptions((prev) => ({ ...prev, projects: _.sortBy(res?.server_access_projects, "project_name") }))
        })
    }, [])

    useEffect(() => {
        if (popupFilters?.project?.project_id) {
            getServerAccessDetails(null, false);
        }
    }, [popupFilters?.project])

    useEffect(() => {
        if (!_.isEmpty(editData) && !_.isEmpty(options?.projects)) {
            setPopupFilters((prev) => ({ ...prev, project: _.findWhere(options?.projects, { project_id: editData?.project_id }) }));
        }
    }, [options?.projects, editData])

    useEffect(() => {
        // set DBwise approvers
        if (!_.isEmpty(popupFilters?.database)) {
            const dbApprovers = popupFilters?.database?.approver_user_codes?.split(",")?.map((item, idx) => { return { user_code: parseInt(item), user_display_name: popupFilters?.database?.approver_user_names?.split(",")?.[idx] } });
            const allApprovers = !_.isEmpty(dbApprovers) ? options?.defaultApprovers?.concat(dbApprovers) : options?.defaultApprovers;
            setOptions((prev) => ({ ...prev, approveBy: allApprovers }));
            if (!_.isEmpty(editData)) {
                const approver = _.findWhere(allApprovers, { user_code: editData?.approver_user_code });
                setPopupFilters((prev) => ({ ...prev, approve_by: approver?.user_code || 0 }));
                setPreviousData((prev) => ({ ...prev, approve_by: approver?.user_code || 0 }));
            }
        }
    }, [popupFilters?.database])

    const getServerAccessDetails = async (serverSelected, apiCallStop) => {
        try {
            const payload = {
                project_id: popupFilters?.project?.project_id || 0,
                server_id: (serverSelected ? serverSelected?.server_id : (_.isEmpty(editData) ? popupFilters?.server?.server_id : editData?.server_id)) || 0
            }
            const res = await services.getInvokeRemote("POST", Urls("GETSERVERACCESSDETAILS"), payload);
            if (res) {
                const servers = _.sortBy(res?.body?.data?.server_details, "server_name");
                const database = _.sortBy(res?.body?.data?.database_details, "database_name");
                const approvers = _.sortBy(_.uniq(res?.body?.data?.approver_details, "user_code"), "user_display_name");
                setOptions((prev) => ({ ...prev, server: servers, database: database || [], defaultApprovers: approvers, approveBy: approvers }));

                if (!_.isEmpty(editData) && !serverSelected) {
                    const selectedServer = _.findWhere(servers, { server_id: editData?.server_id }) || {};
                    const selectedDatabase = _.findWhere(database, { database_id: editData?.database_id }) || {};
                    const time = _.findWhere(options?.time, { value: editData?.request_access_minutes });
                    const approver = _.findWhere(approvers, { user_code: editData?.approver_user_code });
                    setPopupFilters((prev) => ({ ...prev, server: selectedServer, database: selectedDatabase, approve_by: approver?.user_code || 0, time: time, reason: editData?.remark }));
                    setPreviousData({ ...popupFilters, server: selectedServer, database: selectedDatabase, approve_by: approver?.user_code || 0, time: time, reason: editData?.remark });
                } else if (serverSelected) {
                    const selectedDatabase = _.findWhere(database, { database_id: popupFilters?.database?.database_id }) || {};
                    setPopupFilters((prev) => ({ ...prev, database: selectedDatabase }));
                }
                if (servers?.length === 1 && _.isEmpty(editData)) {
                    setPopupFilters((prev) => ({ ...prev, server: servers?.[0] }));
                    !apiCallStop && getServerAccessDetails(servers?.[0], true)
                }
                if (database?.length === 1 && _.isEmpty(editData)) {
                    setPopupFilters((prev) => ({ ...prev, database: database?.[0] }));
                }
            }
        } catch (error) {
            console.error("Error: ", error);
        }
    }

    const handleRequestSubmit = async () => {
        try {
            if (_.isEmpty(popupFilters?.project)) {
                showInfo("info", "Please select project");
                return;
            } else if (_.isEmpty(popupFilters?.server)) {
                showInfo("info", "Please select server");
                return;
            } else if (_.isEmpty(popupFilters?.database)) {
                showInfo("info", "Please select database");
                return;
            } else if (popupFilters?.approve_by === 0) {
                showInfo("info", "Please select an approver");
                return;
            } else if (_.isEmpty(popupFilters?.time)) {
                showInfo("info", "Please select to date");
                return;
            } else if (calculateWordsFromString(popupFilters?.reason) < 5) {
                showInfo("info", "Reason should contain minimum 5 words");
                return;
            } else if (_.isEqual(previousData, popupFilters)) {
                showInfo("info", "No changes made!")
            } else {
                setLoader(true);
                const payload = {
                    "server_access_request_id": _.isEmpty(editData) ? 0 : editData?.server_access_request_id,
                    "server_id": popupFilters?.server?.server_id || 0,
                    "database_id": popupFilters?.database?.database_id || 0,
                    "approver_user_code": parseInt(popupFilters?.approve_by) || 0,
                    "request_access_minutes": popupFilters?.time?.value || 0,
                    "remark": popupFilters?.reason,
                }
                const res = await services.getInvokeRemote("POST", Urls("UPSERTSERVERACCESSREQUEST"), payload);
                if (res) {
                    if (res?.body?.StatusCode === 400 || res?.body?.StatusCode === 204 || res?.body?.StatusCode === 202 || res?.body?.StatusCode === 401 || res?.body?.StatusCode === 500) {
                        showError("Error", res?.body?.message);
                    } else {
                        showSuccess("Success", res?.body?.message);
                        setEditData({});
                        setShowRequestPopup(false);
                        callApi();
                    }
                    setLoader(false);
                }
            }
        } catch (error) {
            console.error("Error", error);
            setLoader(false);
        }
    }

    return useMemo(() => ({
        popupFilters, setPopupFilters, handleRequestSubmit, loader, options, getServerAccessDetails
    }), [popupFilters, setPopupFilters, handleRequestSubmit, loader, options, getServerAccessDetails])
}